module.exports = __webpack_public_path__ + "static/media/home.070a5ea9.png";